module.exports = __webpack_public_path__ + "static/media/W00F0001.63440d53.svg";